import { useContext } from "react";
import { useStore } from "zustand";
import { useShallow } from "zustand/shallow";

import { MultiActivityFormStoreType } from "./multi_activity_form_store.types";
import { MultiActivityFormStoreContext } from "./multi_activity_form_store_context";

export const useMultiActivityFormStore = <U>(selector: (state: MultiActivityFormStoreType) => U) => {
  const store = useContext(MultiActivityFormStoreContext);
  return useStore(store, useShallow(selector));
};

export const useMultiActivityFormStoreActions = () => {
  const store = useContext(MultiActivityFormStoreContext);
  return useStore(store, (state) => state.actions);
};
